import { Localized } from "@fluent/react";
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, Stack } from "@mui/material"
import { useState } from "react";
import { showError, showSuccess } from "../../notifications/notificationsSlice";
import { useAppDispatch } from "../../../app/hooks";
import { SaveButton } from "../../../app/components/SaveButton";
import { CancelButton } from "../../../app/components/CancelButton";
import { createRelease } from "./ReleasesApi";
import { useNavigate } from "react-router-dom";

export interface AddReleaseDialogProps {
    onCancel: () => void
}

export const AddReleaseDialog: React.FC<AddReleaseDialogProps> = ({ onCancel }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch()
    const [saving, setSaving] = useState(false)
    const [serverError, setServerError] = useState("")
    const [type, setType] = useState<string>("");

    const handleTypeChange = (e) => setType(e.target.value);

    const handleSaveClick = async () => {
        setSaving(true)

        try {
            const result = await dispatch(createRelease({ releaseType: type }))
            if (createRelease.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                navigate(`/sys/releases/edit/${result.payload.id}`);

            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }
        }
        catch (error) {
            dispatch(showError("error"));
        }
        finally {
            setSaving(false)
        }
    }

    return <>
        <Dialog open={true} maxWidth="md" fullWidth>
            <DialogTitle>
                <Localized id="releases-create">_Utwórz Release</Localized>
            </DialogTitle>
            <DialogContent>
                <Stack direction="column" spacing={2} padding={2}>
                    <FormControl fullWidth>
                        <InputLabel id="app-type-label"><Localized id="type">_Typ</Localized></InputLabel>
                        <Select
                            labelId="app-type-label"
                            value={type}
                            onChange={handleTypeChange}
                            label={<Localized id="type">_Typ</Localized>}
                            fullWidth
                        >
                            <MenuItem value={'HF'}>HF</MenuItem>
                            <MenuItem value={'RELEASE'}>RELEASE</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>
            <DialogActions>
                <SaveButton onClick={handleSaveClick} loading={saving} />
                <CancelButton onClick={onCancel} loading={saving} />
            </DialogActions>
        </Dialog>
    </>
}

